<template>
  <div class = "fixed-content">

      <rate-form ref="RateFormCreate" 
      mode="BILLING"
      :action="doTest"/>

      <rate-form ref="RateFormChange" 
      mode="BILLING_CHANGE"
      :action="doTest"/>


      <rate-form ref="RateFormCostCreate" 
      mode="COST"
      :action="doTest"/>

      <rate-form ref="RateFormCostChange" 
      mode="COST_CHANGE"
      :action="doTest"/>



    <div >
      <callingApiCenter :paths="['/api/w/gst/gstpriceagreement/create','/api/w/gst/gstpriceagreement/getone','/api/w/gst/gstpriceagreement/update','/api/w/gst/gstpriceagreementitem/update']">
      <md-button class="md-raised custButton "  @click="doAction" ><span class="icons-center material-icons">create</span>BACK</md-button>
      <md-button v-if="(this.$route.params.mode == 'CREATE' || this.$route.params.mode == 'CREATEAC') && showCreate" class="md-raised custButton "  @click="doCreateAgreement" ><span class="icons-center material-icons">create</span>Create</md-button>
      <md-button v-if="this.$route.params.mode == 'COPY' && showCreate" class="md-raised custButton "  @click="doCreateAgreement" ><span class="icons-center material-icons">create</span>COPY</md-button>
      <md-button v-if="this.$route.params.mode == 'CHANGE'" class="md-raised custButton "  @click="doCreateAgreement" ><span class="icons-center material-icons">create</span>CHANGE</md-button>
    </callingApiCenter>
    </div>
    
    <div class=" md-layout md-gutter md-alignment-left ">
    <md-toolbar class="holder  md-layout-item md-size-90">
      <h3 class="md-title ">STC Price Agreement</h3>
    </md-toolbar>
    </div>
    <div class="md-layout md-gutter md-alignment-left ">
        <div class="holder md-layout-item md-size-20">
            <md-field :class="getValidationClass('agreement.agreement')">
                <label>Agreement</label>
                <md-input v-model="agreement.agreement" :disabled="disable == true || this.$route.params.mode == 'CHANGE'"></md-input>
              <div class="md-error" v-if="!$v.agreement.agreement.required">agreement is required<br/></div>
            </md-field>

            



        </div>
        <div class="holder md-layout-item md-size-55">
        <md-field :class="getValidationClass('agreement.adesc')">
                <label>Description: </label>
                <md-input v-model="agreement.adesc" :disabled= "disable"></md-input>
            </md-field>
        </div>
    </div>

    <div class="md-layout md-gutter md-alignment-center ">
        <div class="holder md-layout-item md-size-20">
            <datepicker :class="getValidationClass('agreement.validFrom')" v-model="agreement.validFrom">
              <label>Valid From</label>
            </datepicker>
        </div>
        <div class="holder md-layout-item md-size-20">
            <datepicker :class="getValidationClass('agreement.validTo')" v-model="agreement.validTo">
              <label>Vaild To </label>
            </datepicker>
        </div>
        <div class="holder md-layout-item md-size-30">
        <md-field :class="getValidationClass('agreement.signedBy')">
                <label>Signed By </label>
                <md-input v-model="agreement.signedBy" :disabled= "disable"></md-input>
            </md-field>
        </div>
        <div class="holder md-layout-item md-size"></div>
    </div>


    <div class="md-layout md-gutter md-alignment-center ">
        <div class="holder md-layout-item md-size-20">
            <auto-complete-master-data-select :class="getValidationClass('agreement.salesOffice')"
                                                group="GST_SALEOFFICE"
                                                label="Sales Office"
                                                :init-value="agreement.salesOffice"
                                                :on-item-changed="handleSalesOfficeChanged"
                                                :disabled= "disable"
                                                >
            </auto-complete-master-data-select>
        </div>
        <div class="holder md-layout-item md-size-20">
        <!--  
        <md-field :class="getValidationClass('agreement.payer')">
                <label>Customer </label>
                <md-input v-model="agreement.payer" :disabled= "disable"></md-input>
            </md-field>

          -->   
            <auto-complete-master-data-select :class="getValidationClass('agreement.payer')"
                                                group="STC_CUSTOMER"
                                                label="Customer"
                                                :init-value="agreement.payer"
                                                :on-item-changed="handleCustomerChanged"
                                                :watchValueId="agreement.payer"
                                                :disabled= "disable"
                                                >
            </auto-complete-master-data-select>
        </div>
      
        <div class="holder md-layout-item md-size-20">
            <auto-complete-master-data-select :class="getValidationClass('agreement.paymentTerm')"
                                                group="STC_PAYTERM"
                                                label="Payment Term"
                                                :init-value="agreement.paymentTerm"
                                                :watchValueId="agreement.paymentTerm"
                                                :on-item-changed="handlePaymentTerm"
                                                :disabled= "disable"
                                                >
            </auto-complete-master-data-select>
        </div>


        <div class="holder md-layout-item md-size"></div>
    </div>

    <div class="md-layout md-gutter md-alignment-center ">
        <div class="holder md-layout-item md-size-60">
             <div :class="getValidationClass('agreement.departureCode')">
                <autocomplete-ccic-location-select 
                label="Dept. Point"
                group="STC_TERMINAL"
                v-model="agreement.departureCode"
                :on-item-selected="handleDeptLocationChanged"
                />
                <div class="md-error" v-if="!$v.agreement.departureCode.required">Type 3 dig for search location<br/></div>
            </div>

    
            <div v-if="agreement.departureCode">
                <master-data-display group="STC_TERMINAL" :tag-id="agreement.departureCode"/>
            </div>

             

        </div>
        <div class="holder md-layout-item md-size"></div>
    </div>

     <div class="md-layout md-gutter md-alignment-center ">
        <div class="holder md-layout-item md-size-60">

           
             <div :class="getValidationClass('agreement.destinationCode')">
                
            <autocomplete-ccic-location-select
                label="Dest. Point"
                group="STC_TERMINAL"
                v-model="agreement.destinationCode"
                :on-item-selected="handleDestLocationChanged"
            />
              <div class="md-error" v-if="!$v.agreement.destinationCode.required">Type 3 dig for search location<br/></div>
        </div>


           
            
             <div v-if="agreement.destinationCode">
                <master-data-display group="STC_TERMINAL" :tag-id="agreement.destinationCode"/>
            </div>
           
        </div>

       


         <div class="holder md-layout-item md-size"></div>
    </div>


     <div class="md-layout md-gutter md-alignment-center ">
        <div class="holder md-layout-item md-size-20">
            <md-field :class="getValidationClass('agreement.commodity')">
                <label>Commodity</label>
                <md-input v-model="agreement.commodity" :disabled= "disable"></md-input>
            </md-field>
        </div>
        <div class="holder md-layout-item md-size-20">
        <md-field :class="getValidationClass('agreement.ctnType')">
                <label>Container Type</label>
                <md-input v-model="agreement.ctnType" :disabled= "disable"></md-input>
            </md-field>
        </div>
        <div class="holder md-layout-item md-size-30">
        <md-field :class="getValidationClass('agreement.freeDay')">
                <label>CHS Free Days </label>
                <md-input v-model="agreement.freeDay" :disabled= "disable"></md-input>
            </md-field>
        </div>
        <div class="holder md-layout-item md-size"></div>
    </div>



     <div class="md-layout md-gutter md-alignment-center ">
        <div class="holder md-layout-item md-size-20">
            <md-field :class="getValidationClass('agreement.orderType')">
                <label>Order Type</label>
                <md-input v-model="agreement.orderType" :disabled= "disable"></md-input>
            </md-field>
        </div>
        <div class="holder md-layout-item md-size-20">
        <md-field :class="getValidationClass('agreement.currency')">
                <label>Currency </label>
                <md-input v-model="agreement.currency" :disabled= "disable"></md-input>
            </md-field>
        </div>
        <div class="holder md-layout-item md-size-30">
        <md-field>
                <label>All in Rate </label>
                <md-input v-model="agreement.allInRate" :disabled= "disable"></md-input>
            </md-field>
        </div>
        <div class="holder md-layout-item md-size"></div>
    </div>

    <callingApiCenter :paths="['/api/w/gst/gstpriceagreementitem/update']">
    </callingApiCenter>
    <div v-if="showRate" class = "layoutHalf">
        <div class=" md-layout md-gutter md-alignment-center full">
            <md-toolbar>
            <h3 class="md-title">Billing Rate</h3>
            <md-button class="md-raised custButton "  @click="doCreateBilling" ><span class="icons-center material-icons">create</span>ADD</md-button>
            <md-button v-if="selectedBilling != null"  class="md-raised custButton "  @click="doChangeBilling" ><span class="icons-center material-icons">create</span>EDIT</md-button>
            <md-button v-if="selectedBilling != null"  class="md-raised custButton "  @click="doDeleteBilling" ><span class="icons-center material-icons">create</span>DELETE</md-button>
            </md-toolbar>
        </div>

        <div>
          <md-table v-model="billingItems" md-sort="name" md-sort-order="asc" md-card @md-selected="onSelectBilling">
          <md-table-toolbar v-if="selectedBilling != null">
            <div >
                <h1>{{selectedBilling.rateType}}/{{selectedBilling.rdesc}}</h1>
            </div>
          </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
                <md-table-cell md-label="Rate Type" md-sort-by="rateType">{{ item.rateType }}</md-table-cell>
                <md-table-cell md-label="Description" md-sort-by="rDesc">{{ item.rdesc }}</md-table-cell>
                <md-table-cell md-label="Maeasure Unit" md-sort-by="unit">{{ item.unit }}</md-table-cell>
                <md-table-cell md-label="Unit Price" md-sort-by="amt">{{ item.amt }}</md-table-cell>
                <md-table-cell md-label="Required" md-sort-by="required">{{ item.required }}</md-table-cell>

            </md-table-row>
            </md-table>
        </div>
    </div>


    <div v-if="showRate" class = "layoutHalf">
        <div class=" md-layout md-gutter md-alignment-center full">
            <md-toolbar>
            <h3 class="md-title">Cost Rate</h3>
             <md-button class="md-raised custButton "  @click="doCreateCost" ><span class="icons-center material-icons">create</span>ADD</md-button>
            <md-button v-if="selectedCost != null" class="md-raised custButton "  @click="doChangeCost" ><span class="icons-center material-icons">create</span>EDIT</md-button>
            <md-button v-if="selectedCost != null" class="md-raised custButton "  @click="doDeleteCost" ><span class="icons-center material-icons">create</span>DELETE</md-button>
            </md-toolbar>
        </div>

        <div>
          <md-table v-model="costItems" md-sort="name" md-sort-order="asc" md-card @md-selected="onSelectCost">
          <md-table-toolbar v-if="selectedCost != null">
            <div >
                <h1>{{selectedCost.rateType}}/{{selectedCost.rDesc}}</h1>
            </div>
          </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }"  md-selectable="single">
                <md-table-cell md-label="Rate Type" md-sort-by="rateType">{{ item.rateType }}</md-table-cell>
                <md-table-cell md-label="Description" md-sort-by="rDesc">{{ item.rdesc }}</md-table-cell>
                <md-table-cell md-label="Maeasure Unit" md-sort-by="unit">{{ item.unit }}</md-table-cell>
                <md-table-cell md-label="Unit Price" md-sort-by="amt">{{ item.amt }}</md-table-cell>
                <md-table-cell md-label="Required" md-sort-by="required">{{ item.required }}
                </md-table-cell>
            </md-table-row>
            </md-table>
        </div>
    </div>

    <div class = "foot">

    </div>
   


     




  
    </div>

</template>

<script>

/* eslint-disable no-plusplus */
  import { mapGetters } from 'vuex';
  import { validationMixin } from 'vuelidate';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import dateFormat from '../utils/dateFormat';
  //import api from "../api";
  import { newAPIPost} from '../api/index.js';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  import RateForm from '../components/GSTRateForm.vue';
  import AutocompleteCcicLocationSelect from "../components/AutocompleteCcicLocationSelect.vue";




  const getInitialdataForm = () => ({
        agreement: null,
        adesc: null,
        validFrom: null,
        validTo: null,
        signedBy:null,
        salesOffice: null,
        payer: null,
        departureCode: null,
        destinationCode: null,
        commodity: null,
        freeDay: null,
        ctnType: null,
        orderType: null,
        currency: null,
        allInRate: null,
        paymentTerm: null,
        copyFrom: null,
  });

  const initDispatchLoadSearch = () => ({
    receivingWindow: null,
    salesOffice: null,
    pickupLocation: null,
    bookingNo: null,
    destination: null,
    appointment: null,
    driverId: null,
    driverGroup: null,
    costRelevant: null,
    freightType: null,
    cargoCutOff: {
      startDate: null,
      endDate: null,
    },
    apptDate: {
      startDate: null,
      endDate: null,
    },
    moveInDate: {
      startDate: null,
      endDate: null,
    },
    inGateDate: {
      startDate: null,
      endDate: null,
    },
    loadKey: null,
    source: null,
    containerNo: null,
    chassisNo: null,
    ctnrType: null,
    carrier: null,
    customerOrder: null,
    deliveryOrder: null,
    loadStatus: [],
    pushStatus: null,
    stageType: null,
    filter: null,
    fromPage: null,
    selectDType: null
  });

export default {


    data: () => ({
     agreement: getInitialdataForm(),
     dispatchLoadSearch: initDispatchLoadSearch(),
     params: [],
     pointer: null,
     selectedBilling: null,
     selectedCost: null,
     disable: true,
     showCreate:false,
     showRate: false,
     billingItems: [],
     costItems: [],
     indicator: false,
     drivers: null,
     edit:false,
     photos: [],
     testphotos: [],
     photoZipFileName: '',
     filePrefixForEachFile: '',
     isPictureModalShowing: false,
     fromPage: null
    }),


    components: {
      callingApiCenter,
      AutocompleteCcicLocationSelect,
      RateForm,
  
    },

    mixins: [validationMixin],



    computed: {
        ...mapGetters([
        'getMasterDataName',
        'getMasterDataByGroup',
        'getMasterDataAsSelectOptionByGroup',
        'getPermission',
        'getUserProfile',
        'getRole',
      ]),




      getEditMode()
        {
            return this.edit;
        },

    

    },



    


    async mounted() {

        console.log(this.$v.agreement.destinationCode.required);
        console.log(this.$route.params);
        if (this.$route.params.mode == "CREATE" || 
            this.$route.params.mode == 'CREATEAC')
        {
            if (this.$route.params.mode == 'CREATEAC') {
                this.agreement.agreement = this.$route.params.agreement;
                const agreement = this.$route.params.agreement;
                const salesOffice = this.$route.params.salesOffice;
                this.agreement.salesOffice = salesOffice;
                this.agreement.agreement = this.$route.params.additionchargeagreement;

                //const res = await api.post("/api/w/gst/gstpriceagreement/getone", {
                const res = await newAPIPost("/api/w/gst/gstpriceagreement/getone", {
                    agreement, salesOffice
                 });
                    this.$store.commit('clearApiError');
                    console.log(res.paymentTerm);
                    this.agreement.paymentTerm = res.paymentTerm;
                    this.agreement.adesc = res.adesc;
                    this.agreement.validFrom = dateFormat.date(res.validFrom);
                    this.agreement.validTo = dateFormat.date(res.validTo);
                    this.agreement.signedBy = res.signedBy;
                    this.agreement.payer = res.payer;
                    this.agreement.departureCode = res.departureCode;
                    this.agreement.destinationCode = res.destinationCode;
                    this.agreement.commodity = res.commodity;
                    this.agreement.freeDay = res.freeDay;
                    this.agreement.ctnType = res.ctnType;
                    this.agreement.orderType = res.orderType;
                    this.agreement.currency = res.currency;
                    this.agreement.allInRate = res.allInRate;
                    this.billingItems = res.billingItem;
                    this.costItems = res.costItem;
                    

              }
            this.disable = false;
            this.showCreate = true;
        }

        if (this.$route.params.from && this.$route.params.from == 'LOAD' 
             && this.$route.params.searchCriteria) {
           console.log("incoming dispatch load criteria: " + JSON.stringify(this.$route.params.searchCriteria));
           var loadsearchcriteria = JSON.parse(this.$route.params.searchCriteria);
           this.fromPage = this.$route.params.from;
           this.storeDispatchLoadSearchCriteria(loadsearchcriteria);
        }


        if (this.$route.params.mode == "COPY")
        {
            this.disable = false;
            this.showCreate = true;
            console.log(this.$route.params);
            const param = this.$route.params;

            this.agreement.agreement = param.agreement;
            this.agreement.adesc = param.adesc;
            this.agreement.validFrom = dateFormat.date(param.validFrom);
            this.agreement.validTo = dateFormat.date(param.validTo);
            this.agreement.signedBy = param.signedBy;
            this.agreement.salesOffice = param.salesOffice;
            this.agreement.payer = param.payer;
            this.agreement.departureCode = param.departureCode;
            this.agreement.destinationCode = param.destinationCode;
            this.agreement.commodity = param.commodity;
            this.agreement.freeDay = param.freeDay;
            this.agreement.ctnType = param.ctnType;
            this.agreement.orderType = param.orderType;
            this.agreement.currency = param.currency;
            this.agreement.allInRate = param.allInRate;
            this.agreement.paymentTerm = param.paymentTerm;
            this.agreement.copyFrom = param.agreement;
            
        }




        if (this.$route.params.mode == "CHANGE")
        {
            this.disable = false;
            this.showRate = true;
            const agreement = this.$route.params.agreement;
            const salesOffice = this.$route.params.salesOffice;
            this.agreement.salesOffice = salesOffice;
            this.agreement.agreement = agreement;

            //const res = await api.post("/api/w/gst/gstpriceagreement/getone", {
            const res = await newAPIPost("/api/w/gst/gstpriceagreement/getone", {
                    agreement, salesOffice
                });
                    this.$store.commit('clearApiError');
                    console.log(res.paymentTerm);
                    this.agreement.paymentTerm = res.paymentTerm;
                    this.agreement.adesc = res.adesc;
                    this.agreement.validFrom = dateFormat.date(res.validFrom);
                    this.agreement.validTo = dateFormat.date(res.validTo);
                    this.agreement.signedBy = res.signedBy;
                    this.agreement.payer = res.payer;
                    this.agreement.departureCode = res.departureCode;
                    this.agreement.destinationCode = res.destinationCode;
                    this.agreement.commodity = res.commodity;
                    this.agreement.freeDay = res.freeDay;
                    this.agreement.ctnType = res.ctnType;
                    this.agreement.orderType = res.orderType;
                    this.agreement.currency = res.currency;
                    this.agreement.allInRate = res.allInRate;
                    this.billingItems = res.billingItem;
                    this.costItems = res.costItem;
                    
        }
        
        
    
        this.doSearch();
    },


    validations: {


      agreement: {
          agreement: {
          required,
        },

        adesc: {
          required,
        },

        validFrom: {
          required,
        },

        validTo: {
          required,
        },

        signedBy: {
          required,
        },

        salesOffice: {
          required,
        },

        payer: {
          required,
        },

        departureCode: {
          required,
        },

        destinationCode: {
          required,
        },

        commodity: {
          required,
        },

        freeDay: {
          required,
        },
        ctnType: {
          required,
        },
        orderType: {
          required,
        },
        currency: {
          required,
        },
        paymentTerm: {
          required,
        },


      },
    },




    methods: {



        async reloadItems(agreement, salesOffice){
          this.disable = false;
          this.showRate = true;
          //const res = await api.post("/api/w/gst/gstpriceagreement/getone", {
          const res = await newAPIPost("/api/w/gst/gstpriceagreement/getone", {
                    agreement, salesOffice
                });
                    this.$store.commit('clearApiError');
                    this.agreement.adesc = res.adesc;
                    this.agreement.validFrom = res.validFrom;
                    this.agreement.validTo = res.validTo;
                    this.agreement.signedBy = res.signedBy;
                    this.agreement.payer = res.payer;
                    this.agreement.departureCode = res.departureCode;
                    this.agreement.destinationCode = res.destinationCode;
                    this.agreement.commodity = res.commodity;
                    this.agreement.freeDay = res.freeDay;
                    this.agreement.ctnType = res.ctnType;
                    this.agreement.orderType = res.orderType;
                    this.agreement.currency = res.currency;
                    this.agreement.allInRate = res.allInRate;
                    this.billingItems = res.billingItem;
                    this.costItems = res.costItem;
                    this.agreement.paymentTerm = res.paymentTerm;
        },

        storeDispatchLoadSearchCriteria(searchcriteria) {
          if (searchcriteria) {
             console.log("storeDispatchLoadSearchCriteria: " + JSON.stringify(searchcriteria));
            this.dispatchLoadSearch.containerNo = searchcriteria.containerNo;
            this.dispatchLoadSearch.receivingWindow = searchcriteria.receivingWindow;
            this.dispatchLoadSearch.salesOffice = searchcriteria.salesOffice;
            console.log("dispatch load search salesOffice: " + this.dispatchLoadSearch.salesOffice);
            this.dispatchLoadSearch.pickUpLocation = searchcriteria.pickUpLocation;
            this.dispatchLoadSearch.bookingNo = searchcriteria.bookingNo;
            this.dispatchLoadSearch.destination = searchcriteria.destination;
            this.dispatchLoadSearch.appointment = searchcriteria.appointment;
            this.dispatchLoadSearch.driveId = searchcriteria.driverId;
            this.dispatchLoadSearch.driverGroup = searchcriteria.driverGroup;
            this.dispatchLoadSearch.costRelevant = searchcriteria.costRelevant;
            this.dispatchLoadSearch.freightType = searchcriteria.freightType;
            if (searchcriteria.cargoCutOff != null && searchcriteria.cargoCutOff.startDate != null) {
               this.dispatchLoadSearch.cargoCutOff.startDate = searchcriteria.cargoCutOff.startDate;
            }
            if (searchcriteria.cargoCutOff != null && searchcriteria.cargoCutOff.endDate != null) {
               this.dispatchLoadSearch.cargoCutOff.endDate = searchcriteria.cargoCutOff.endDate;
            }
            if (searchcriteria.apptDate != null && searchcriteria.apptDate.startDate != null) {
               this.dispatchLoadSearch.apptDate.startDate = searchcriteria.apptDate.startDate;
            }
            if (searchcriteria.apptDate != null && searchcriteria.apptDate.endDate != null) {
               this.dispatchLoadSearch.apptDate.endDate = searchcriteria.apptDate.endDate;
            }
            if (searchcriteria.moveInDate != null && searchcriteria.moveInDate.startDate != null) {
               this.dispatchLoadSearch.moveInDate.startDate = this.convertDateForDatePicker(searchcriteria.moveInDate.startDate,"");
            }
            if (searchcriteria.moveInDate != null && searchcriteria.moveInDate.endDate != null) {
               this.dispatchLoadSearch.moveInDate.endDate = this.convertDateForDatePicker(searchcriteria.moveInDate.endDate,"");
            }
            if (searchcriteria.inGateDate != null && searchcriteria.inGateDate.startDate != null) {
               this.dispatchLoadSearch.inGateDate.startDate = this.convertDateForDatePicker(searchcriteria.inGateDate.startDate,"");
            }
            if (searchcriteria.inGateDate != null && searchcriteria.inGateDate.endDate != null) {
               this.dispatchLoadSearch.inGateDate.endDate = this.convertDateForDatePicker(searchcriteria.inGateDate.endDate,"");
            }
            this.dispatchLoadSearch.loadKey = searchcriteria.loadKey;
            this.dispatchLoadSearch.source = searchcriteria.source;
            this.dispatchLoadSearch.chassisNo = searchcriteria.chassisNo;
            this.dispatchLoadSearch.ctnrType = searchcriteria.ctnrType;
            this.dispatchLoadSearch.carrier = searchcriteria.carrier;
            this.dispatchLoadSearch.customerOrder = searchcriteria.customerOrder;
            this.dispatchLoadSearch.deliveryOrder = searchcriteria.deliveryOrder;
            this.dispatchLoadSearch.loadStatus = searchcriteria.loadStatus;
            this.dispatchLoadSearch.pushStatus = searchcriteria.pushStatus;
            this.dispatchLoadSearch.stageType = searchcriteria.stageType;
            this.dispatchLoadSearch.filter = searchcriteria.filter;
            this.dispatchLoadSearch.selectDType = searchcriteria.selectDType;
            this.dispatchLoadSearch.fromPage = searchcriteria.fromPage;
          }
          console.log("after store load criteria: " + JSON.stringify(this.dispatchLoadSearch));
      },

      convertDateForDatePicker(date, type) {
        var day = "";
        var month = "";
        var year = "";
        if (date) {
           //console.log("date input: " + date);
          //  if (date.toString().indexOf("T") > 0) {
          //     dateString = date.toString().substr(1, date.toString().indexOf("T") - 1);
          //     console.log("convert date for date picker: " + Date(dateString).getMonth());
          //     return moment(dateString);      
          //  }   
          //  else {
          //     return date;
          //  }
          if (date.indexOf("T") < 1 && date.indexOf("-") > 1) date = date + "T00:00:00" 
          var processDate = new Date(date);
          year = processDate.getFullYear();
          month = processDate.getMonth() + 1;
          day = processDate.getDate();
          if (month && month.toString().length < 2) {
             month = "0" + month;
          }
          if (day && day.toString().length < 2) {
             day = "0" + day;
          }
          //console.log("date (" + type + ") input in format: " +  month + "/" + day + "/" + year );
          return month + "/" + day + "/" + year;
        }
        else {
          //console.log("no date (" + type + ") input in format: ");
          return date;
        }
      },

        getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);

        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },

       handleSalesOfficeChanged(id) {
        this.agreement.salesOffice = id;
      },

       handlePaymentTerm(id) {
        this.agreement.paymentTerm = id;
       },

       handleCustomerChanged(id) {
        //this.agreement.payer = this.getMasterDataName('STC_CUSTOMER',id) + " (" + id + ")";
        this.agreement.payer = id;
        console.log("id: " + id + ", agreement.customer: " + this.agreement.payer);
       },

      handleDeptLocationChanged(item) {
        if (item) {
          
          this.agreement.departureCode = item.tagId;
        } else {
          this.agreement.departureCode = null;
        }
      },


      handleDestLocationChanged(item) {
        if (item) {
          
          this.agreement.destinationCode = item.tagId;
        } else {
          this.agreement.destinationCode = null;
        }
      },

    onSelectBilling (item) {
        this.selectedBilling = item;
      },

    onSelectCost (item) {
        this.selectedCost = item;
      },




      doCreateAgreement() {
        this.$v.agreement.$touch();
        console.log(`doSaveUser , invalid=${this.$v.agreement.$invalid}`);
        if (this.$v.agreement.$invalid) {
          return;
        }
        const req = this.agreement;
        req.validFrom = dateFormat.getLocalDate(this.agreement.validFrom);
        req.validTo = dateFormat.getLocalDate(this.agreement.validTo);
        console.log("req: " + JSON.stringify(req));

        if (this.$route.params.mode == 'CREATE' || this.$route.params.mode == 'CREATEAC' 
                    || this.$route.params.mode == 'COPY')
        {
            //api.post("/api/w/gst/gstpriceagreement/create", req)
            newAPIPost("/api/w/gst/gstpriceagreement/create", req)
                .then((res) => {
                    this.$store.commit('clearApiError');
                    this.showCreate = false;
                    this.showRate = true;
                    this.disable = true;
                   this.reloadItems(res.agreement, res.salesOffice);
                });

            if (this.$route.params.deliveryOrder != null){
              this.$route.params.action = "UPDATE"
              this.$route.params.agreement = this.agreement.agreement
              //api.post("/api/w/do/doheader/action", this.$route.params)
              newAPIPost("/api/w/do/doheader/action", this.$route.params)
            }
            
        }

        if (this.$route.params.mode == 'CHANGE')
        {
             //api.post("/api/w/gst/gstpriceagreement/update", req)
             newAPIPost("/api/w/gst/gstpriceagreement/update", req)
                .then(() => {
                    this.$store.commit('clearApiError');
                    
                });
        }
        
      },

      doCreateBilling() {
          const request = {
              agreement: this.agreement.agreement
          }
          this.$refs.RateFormCreate.openDialog(request);
      },

      doChangeBilling() {
          this.$refs.RateFormChange.openDialog(this.selectedBilling);
      },

      async doDeleteBilling() {
          const req = this.selectedBilling;
          req.mode = 'D';
          //await  api.post("/api/w/gst/gstpriceagreementitem/update", req)
          await  newAPIPost("/api/w/gst/gstpriceagreementitem/update", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.selectedBilling = null;
            this.doTest('Item Delected!');
          });

      },



      doCreateCost() {
          const request = {
              agreement: this.agreement.agreement
          }
          this.$refs.RateFormCostCreate.openDialog(request);
      },

      doChangeCost() {
          this.$refs.RateFormCostChange.openDialog(this.selectedCost);
      },

      async doDeleteCost() {
          const req = this.selectedCost;
          req.mode = 'D';
          //await  api.post("/api/w/gst/gstpriceagreementitem/update", req)
          await  newAPIPost("/api/w/gst/gstpriceagreementitem/update", req)
          .then(() => {
            this.$store.commit('clearApiError');
            this.showDialog = false;
            this.selectedCost = null;
            this.doTest('Item Delected!');
          });

      },











        doEdit(){
            
            this.params.change = true;
            this.edit = true
            console.log(this.params.change);
            console.log(this.getEditMode);
             console.log(this.params);
        },

         doAction(){
            if (this.$route.params.from != 'LOAD') {
               this.$router.go(-1);
            } else {
               this.doBack2DispatchLoad(); 
            }   
         },

         doBack2DispatchLoad() {
            var request = this.dispatchLoadSearch;
            console.log("req: " + JSON.stringify(request));
            this.$router.push({  
                name: "Load" , 
                params: { req: JSON.stringify(request) }})
         },

         async  doTest(item){
            console.log(item);
            // const agreement = this.$route.params[0].agreement;
            // const salesOffice = this.$route.params[0].salesOffice;
            const agreement = this.agreement.agreement;
            const salesOffice = this.agreement.salesOffice;
            // this.agreement.salesOffice = salesOffice;
            // this.agreement.agreement = agreement;
            //const res = await api.post("/api/w/gst/gstpriceagreement/getone", {
            const res = await newAPIPost("/api/w/gst/gstpriceagreement/getone", {
                    agreement, salesOffice
                });
            this.billingItems = res.billingItem;
            this.costItems = res.costItem;

          
        },



        doCancel(item){
            item.editing = false;
        },

        canEdit(item){
          return item.editing != null
      },

        doSearch()
    {
        // if (this.params != null)
        // {
        //     const data = {
        //     loadKey: this.params.loadKey || this.params.seqNo,
        //     companyOffice: 'GST_' + this.params.salesOffice
        //         }
        //     console.log(data);
        //     api.post("/api/w/gst/WebSearchCockpit", data)
        //   .then((item) => {
        //     this.$store.commit('clearApiError');
        //     item.forEach((it) => {
        //     it.editing = false;
        //   });

        //     this.items = item;
        //     console.log(this.items);
        //   });

        // }
    },
    }

}
</script>

<style scoped>

.custButton {
    margin: 10px;
    width: 110px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}

.layoutHalf{
      display:inline-block;
      padding-top: 7px;
      padding-bottom: 7px;
      width: 50%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
      padding-left: 15px;
  }


  .full{
      display:inline-block;
      padding-top: 7px;
      padding-bottom: 7px;
      width: 95%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
      padding-left: 15px;
  }


.foot{
    margin-top: 100px;
}

.photoFont {
    font-size: 1rem;
    color: gray;
    padding-bottom: 10px;
    
}




.holder {
    /* background: blue; */
    margin: 20px;
    width: 800px;
    height: 200px;
    margin-left: 50px;
}

.header{
    text-align: left;
}

.fixed-content {
    padding-left: 10%;
    padding-right: 10%;
    position:fixed;
    overflow-y:auto;
    overflow-x:hidden;
}

.md-layout-item {
  height: 50px;
  margin-top: 8px;
  margin-bottom: 8px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  /* border:1px solid #000; */
  /* background: #ce93d8; */
}

.md-title {
    margin-left: 20px;
}



</style>